import { CircularProgress } from '@mui/material'
import { CredentialResponse, GoogleLogin, TokenResponse, useGoogleLogin } from '@react-oauth/google'
import { useMutation } from '@tanstack/react-query'
import { AppBox, AppButton, AppTypography } from 'components/base'
import { ApiQueryKeys } from 'globals/constants'
import { useLogin } from 'hooks'
import { useSnackbar } from 'notistack'
import { AuthApi, SessionModel } from 'sdk'

export const GoogleSignUpButton = () => {
  const authApi = new AuthApi()
  const { handleLoginSuccess } = useLogin()
  const { enqueueSnackbar } = useSnackbar()

  const { mutate: verify, isPending } = useMutation({
    mutationKey: [ApiQueryKeys.auth.googleSignUp],
    mutationFn: (token: string) => authApi.googleSignUp({ Token: token }),
    onSuccess: (data: SessionModel) => handleLoginSuccess(data),
    onError: (err) => enqueueSnackbar(err.message, { variant: 'error' }),
  })

  const onSuccess = (response: Omit<TokenResponse, 'error' | 'error_description' | 'error_uri'>) => {
    verify(response.access_token!)
  }

  const onError = () => {
    enqueueSnackbar('SignUp Failed, please try again later', { variant: 'error' })
  }
  const googleLogin = useGoogleLogin({
    onSuccess: (res) => onSuccess(res),
    onError: () => onError(),
  })
  return (
    <>
      <AppButton
        variant="outlined"
        color="secondary"
        prefixIcon="flat-color-icons:google"
        size="large"
        sidePaddings={2}
        isLoading={isPending}
        onClick={() => googleLogin()}
      >
        <AppTypography fontSize={16} fontWeight={600} color={'grey.900'}>
          Sign in using Google
        </AppTypography>
      </AppButton>
    </>
  )
}
